import React, { useEffect, useRef } from 'react';
import c from 'classnames';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import useLayoutVariables from '../../../hooks/useLayoutVariables';
import type { ParagraphHtmlEmbed as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphHtmlEmbedProps extends React.HTMLProps<HTMLDivElement> {
  entity: ImmutableEntity<Type>;
}

const dangerouslySetInnerHtml = (element: HTMLElement, html: string) => {
  if (element) {
    const range = document.createRange();
    range.selectNodeContents(element);
    range.deleteContents();
    element.replaceChildren(range.createContextualFragment(html));
  }
};

const ParagraphEmbedHtml: React.FC<ParagraphHtmlEmbedProps> = ({ entity, className, ...props }) => {
  /* Below we deliberately use the value here so VNL can use html */
  const body = entity.getIn(['field_body', 0, 'value'], '');
  const title = entity.getIn(['field_title', 0, 'value'], null) as string | null;

  const embedRef = useRef<HTMLDivElement>(null);

  const { contentColClasses } = useLayoutVariables('paragraphHtmlEmbed');

  useEffect(() => {
    if (embedRef.current) {
      dangerouslySetInnerHtml(embedRef.current, body);
    }
  }, [embedRef, body]);

  return (
    <div className={c('Paragraph ParagraphHtmlEmbed', className)} {...props}>
      <Container>
        <div className="row">
          <div className={contentColClasses}>
            {title && (
              <h2>{title}</h2>
            )}
            <div className="ParagraphHtmlEmbed__embed" ref={embedRef} />
          </div>
        </div>
      </Container>+
    </div>
  );
};

export default ParagraphEmbedHtml;
